import { render, staticRenderFns } from "./QRCodeLeave.vue?vue&type=template&id=c66ca14a&scoped=true"
import script from "./QRCodeLeave.vue?vue&type=script&lang=js"
export * from "./QRCodeLeave.vue?vue&type=script&lang=js"
import style0 from "./QRCodeLeave.vue?vue&type=style&index=0&id=c66ca14a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66ca14a",
  null
  
)

export default component.exports